import AddNewStockAdjustment from './views/AddNewStockAdjustment.vue';

// Inventory Views Exports
export { default as InventoryCenter } from './views/InventoryCenter.vue';
export { default as BuildAssembly } from './views/BuildAssembly.vue';
export { default as StockAdjustment } from './views/StockAdjustment.vue';
export { default as NewInventoryItem } from './views/NewInventoryItem.vue';
export { default as InventoryItems } from './views/InventoryItems.vue';
export { AddNewStockAdjustment };
export { default as NewInventoryAssembly } from './views/NewInventoryAssembly.vue';

// Inventory Routes
export const inventoryRoutes = [
    {
        path: 'inventory/center',
        name: 'InventoryCenter',
        component: () => import('./views/InventoryCenter.vue'),
    },
    {
        path: 'inventory/build-assembly',
        name: 'BuildAssembly',
        component: () => import('./views/BuildAssembly.vue'),
    },
    {
        path: 'inventory/stock-adjustment',
        name: 'StockAdjustment',
        component: () => import('./views/StockAdjustment.vue'),
    },
    {
        path: 'inventory/new-item',
        name: 'NewInventoryItem',
        component: () => import('./views/NewInventoryItem.vue'),
    },
    {
        path: 'inventory/items',
        name: 'InventoryItems',
        component: () => import('./views/InventoryItems.vue'),
    },
    {
        path: 'inventory/stock-adjustment/new',
        name: 'AddNewStockAdjustment',
        component: AddNewStockAdjustment,
    },
    {
        path: 'inventory/new-assembly',
        name: 'NewInventoryAssembly',
        component: () => import('./views/NewInventoryAssembly.vue'),
    },
];
